import type { SVGProps } from 'react';
import * as React from 'react';

const TruckIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>
    <g id="solid/truck">
      <g id="Icon">
        <path
          d="M7.80002 3.59961C6.53858 3.59961 5.28806 3.6471 4.05017 3.74042C3.10744 3.81148 2.40002 4.60103 2.40002 5.52715V12.5996H13.2V5.52715C13.2 4.60103 12.4926 3.81148 11.5499 3.74042C10.312 3.6471 9.06147 3.59961 7.80002 3.59961Z"
          fill="currentColor"
        />
        <path
          d="M2.40002 14.3996V17.3996C2.40002 18.3937 3.20591 19.1996 4.20002 19.1996H4.2498C4.53545 17.497 6.01623 16.1996 7.80002 16.1996C9.58382 16.1996 11.0646 17.497 11.3502 19.1996H12.3C12.7971 19.1996 13.2 18.7967 13.2 18.2996V14.3996H2.40002Z"
          fill="currentColor"
        />
        <path
          d="M7.80002 21.5996C8.79414 21.5996 9.60002 20.7937 9.60002 19.7996C9.60002 18.8055 8.79414 17.9996 7.80002 17.9996C6.80591 17.9996 6.00002 18.8055 6.00002 19.7996C6.00002 20.7937 6.80591 21.5996 7.80002 21.5996Z"
          fill="currentColor"
        />
        <path
          d="M15.9 5.99961C15.403 5.99961 15 6.40255 15 6.89961V17.1163C15.6369 16.5462 16.478 16.1996 17.4 16.1996C19.0577 16.1996 20.4536 17.32 20.872 18.8448C21.3167 18.5143 21.6045 17.9819 21.586 17.3723C21.4761 13.7563 20.7261 10.2998 19.4448 7.1133C19.1692 6.42786 18.5048 5.99961 17.7875 5.99961H15.9Z"
          fill="currentColor"
        />
        <path
          d="M17.4 21.5996C18.3941 21.5996 19.2 20.7937 19.2 19.7996C19.2 18.8055 18.3941 17.9996 17.4 17.9996C16.4059 17.9996 15.6 18.8055 15.6 19.7996C15.6 20.7937 16.4059 21.5996 17.4 21.5996Z"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
);
export default TruckIcon;
